<textarea [name]="name" [id]="name" #host></textarea>